<template>
  <div class="main_box">
    <h2 class="hidden-md-and-up">企业管理</h2>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            <span class="condition_item_lable">企业名称：</span>
            <el-input
              v-model="companyQuery.KeyWord"
              placeholder="企业名称"
              clearable
            ></el-input>
          </div>
          <div class="condition_item">
            <span class="condition_item_lable">用户：</span>
            <el-input
              v-model="companyQuery.UserKeyWord"
              placeholder="企业用户"
              clearable
            ></el-input>
          </div>
          <div class="condition_item">
            <el-button type="primary" @click="search()">查询</el-button>
            <el-button @click="refresh()" size="small" plain> 刷新 </el-button>
          </div>
        </div>
        <div class="form_bar_btn">
          <el-button type="primary" @click="openEditCompany(null)">
            新增企业
          </el-button>
        </div>
      </div>
      <div class="table-block" style="border-top: 0px">
        <el-table
          :data="companyList.Items"
          highlight-current-row
          style="width: 100%"
        >
          <el-table-column
            type="index"
            :index="indexMethod"
            label="序号"
            width="70"
          ></el-table-column>
          <el-table-column
            label="名称"
            min-width="180"
            align="left"
            key="CompanyName"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.CompanyName }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="企业编码"
            min-width="180"
            align="left"
            key="OrgCode"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.OrgCode }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            label="创建时间"
            width="120"
            align="left"
            key="CreateDate"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.CreateDate }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="剩余场次"
            min-width="160"
            align="left"
            key="BalanceInfo"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.BalanceInfo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="scope">
              <el-link
                type="primary"
                title="用户管理"
                class="cell_link"
                @click="openCompanyUser(scope.row.CompanyID)"
              >
                <i class="el-icon-user-solid"></i>
                用户管理
              </el-link>
              <el-link
                type="primary"
                title="编辑"
                class="cell_link"
                @click="openEditCompany(scope.row.CompanyID)"
              >
                <i class="el-icon-edit"></i>
                编辑
              </el-link>
              <el-link
                type="primary"
                title="删除"
                class="cell_link"
                @click.stop
                @click="deleteCompany(scope.row)"
                v-if="false"
              >
                <i class="el-icon-delete"></i>
                删除
              </el-link>
              <el-link
                type="primary"
                title="充值"
                class="cell_link"
                @click="openPayMoney(scope.row.CompanyID)"
              >
                <i class="el-icon-money"></i>
                充值
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination_box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="companyQuery.MaxResultCount"
            :page-sizes="[10, 20, 30, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="companyList.TotalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="this.companyForm.CompanyID === null ? '新增企业' : '编辑企业'"
      :visible.sync="editCompanyDialogVisible"
      custom-class="custom_dialog"
      :close-on-click-modal="false"
      @close="editCompanyDialogClose"
    >
      <el-row>
        <el-col :span="22" :offset="1">
          <el-form
            :model="companyForm"
            :rules="companyFormRules"
            ref="companyForm"
            label-width="120px"
            class="demo-ruleForm"
            size="mini"
            :label-position="is_xs ? 'top' : 'left'"
          >
            <el-form-item label="企业名称：" prop="CompanyName">
              <el-input
                v-model="companyForm.CompanyName"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editCompanyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editCompany()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="充值"
      :visible.sync="payDialogVisible"
      custom-class="custom_dialog"
      :close-on-click-modal="false"
    >
      <el-row>
        <el-col :span="22" :offset="1">
          <el-form
            :model="payForm"
            :rules="payFormRules"
            ref="payForm"
            label-width="120px"
            class="demo-ruleForm"
            size="mini"
            :label-position="is_xs ? 'top' : 'left'"
          >
            <el-form-item label="企业名称：" prop="IsYearVip">
              <el-radio v-model="payForm.IsYearVip" :label="false">
                添加场次
              </el-radio>
              <el-radio v-model="payForm.IsYearVip" :label="true">
                延长时间
              </el-radio>
            </el-form-item>
            <el-form-item
              label="场次："
              prop="Frequency_FREE"
              v-if="!payForm.IsYearVip"
            >
              <el-input-number
                v-model="payForm.Frequency_FREE"
                :min="1"
                :max="100"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="截止日期："
              prop="VipStopTime"
              v-if="payForm.IsYearVip"
            >
              <el-date-picker
                v-model="payForm.VipStopTime"
                type="date"
                placeholder="选择截止日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="payDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="adminRecharge()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import companyApi from '../../../api/company'
export default {
  data () {
    return {
      companyQuery: {
        KeyWord: null,
        UserKeyWord: null,
        MaxResultCount: 10,
        SkipCount: 0
      },
      companyList: {},
      currentPage: 1,
      editCompanyDialogVisible: false,
      companyForm: {
        CompanyID: null,
        CompanyName: null
      },
      companyFormRules: {
        CompanyName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 255, message: '名称过长！', trigger: 'blur' }]
      },
      payDialogVisible: false,
      payForm: {
        CompanyID: null,
        IsYearVip: false,
        Frequency_FREE: 1,
        VipStopTime: null
      },
      payFormRules: {
        Frequency_FREE: [
          { required: true, message: '请输入场次', trigger: 'blur' }],
        VipStopTime: [
          { required: true, message: '请输入截止日期', trigger: 'blur' }]
      }
    }
  },
  methods: {
    indexMethod (index) {
      return this.companyQuery.SkipCount + index + 1
    },
    getCompanys: function () {
      const _this = this
      _this.openLoading()
      companyApi.getCompanys(_this.companyQuery).then(data => {
        _this.companyList = data
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    handleSizeChange (val) {
      this.companyQuery.MaxResultCount = val
      this.getCompanys()
    },
    handleCurrentChange (val) {
      this.companyQuery.SkipCount = (val - 1) * this.companyQuery.MaxResultCount
      this.getCompanys()
    },
    search: function () {
      this.getCompanys()
    },
    refresh: function () {
      this.getCompanys()
    },
    openEditCompany: function (companyID) {
      const _this = this
      _this.editCompanyDialogVisible = true
      _this.companyForm.CompanyID = companyID
      if (companyID) {
        const editLoading = this.openLoading()
        companyApi.getCompany({ companyId: companyID }).then(data => {
          _this.companyForm = data
          editLoading.close()
        }).catch(err => {
          editLoading.close()
          return err
        })
      } else {
        _this.companyForm.CompanyName = null
      }
    },
    editCompanyDialogClose: function (done) {
      const _this = this
      _this.$refs.companyForm.clearValidate()
    },
    editCompany: function () {
      const _this = this
      _this.$refs.companyForm.validate((valid) => {
        if (valid) {
          const editLoading = this.openLoading()
          companyApi.editCompanyInfo(_this.companyForm).then(data => {
            _this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功！',
              customClass: 'custom_message'
            })
            _this.editCompanyDialogVisible = false
            _this.getCompanys()
          }).catch(err => {
            editLoading.close()
            _this.editCompanyDialogVisible = false
            return err
          })
        } else {
          return false
        }
      })
    },
    deleteCompany: function (row) {
      const _this = this
      _this.$confirm('确定要删除企业“' + row.CompanyName + '”吗？', '提示-删除企业', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        const editLoading = _this.openLoading()
        companyApi.deleteCompany({ companyId: row.CompanyID }).then(data => {
          _this.getCompanys()
          _this.$message({
            showClose: true,
            type: 'success',
            message: '企业已删除！',
            customClass: 'custom_message'
          })
          editLoading.close()
        }).catch(err => {
          editLoading.close()
          return err
        })
      }).catch(() => {
        _this.$message({
          showClose: true,
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    openCompanyUser: function (companyId) {
      this.$router.push({ name: 'companyUser', params: { cid: companyId } })
    },
    openPayMoney: function (companyId) {
      this.payDialogVisible = true
      this.payForm.CompanyID = companyId
    },
    adminRecharge: function () {
      const _this = this
      _this.$refs.payForm.validate((valid) => {
        if (valid) {
          _this.openLoading()
          _this.$api.moneyUsering.adminRecharge(_this.payForm).then(data => {
            _this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功！',
              customClass: 'custom_message'
            })
            _this.payDialogVisible = false
            _this.getCompanys()
          }).catch(err => {
            _this.openLoading().close()
            _this.payDialogVisible = false
            return err
          })
        } else {
          return false
        }
      })
    }
  },
  created () {
    this.getCompanys()
  }
}
</script>
<style lang="less">
</style>
